<template>
  <div :class="{ applyBackdrop: applyBackdrop }">
    <div class="SuccessModalWrapper">
      <v-icon
        class="successIcon"
        name="check-circle"
        scale="5"
        color="#48B9BA"
      ></v-icon>
      <h3>{{ title.toUpperCase() }}</h3>
      <button-global
        text="OK"
        type="positive"
        @eventPassed="$emit('successEventPassed')"
      ></button-global>
    </div>
  </div>
</template>

<script>
import ButtonGlobal from "./ButtonGlobal";

export default {
  props: {
    title: String,
    applyBackdrop: Boolean,
  },
  components: {
    ButtonGlobal,
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h3 {
  color: #707070;
}
.SuccessModalWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background-color: white;
  width: 500px;
  height: 400px;
  border-radius: 5px;
  padding: 5px 0;
}
.SuccessModalWrapper > img {
  margin-top: 15px;
  width: 150px;
}
.SuccessModalWrapper > h3 {
  font-size: 20px;
  font-weight: 100;
  margin-bottom: 25px;
}
div.applyBackdrop {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
